import { useConfig } from '../auth'
import { redirectToProvider, Client, settings } from '../lib/allauth'
import Button from '../components/Button'
import GoogleOneTap from './GoogleOneTap'
import React from "react";

export default function ProviderList (props) {
  const config = useConfig()
  const providers = config.data.socialaccount.providers
  if (!providers.length) {
    return null
  }
  return (
    <>
      {settings.client === Client.BROWSER && <>
        {providers.map(provider => {
          return (
            <div id={`login${provider.id}`} key={provider.id}>
              <Button onClick={() => redirectToProvider(provider.id, props.callbackURL, props.process)}>
                {provider.id === 'microsoft' && <div style={{marginRight: '10px', height:23, width:23}}>
                    <svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#f25022" d="M1 1h10v10H1z"/>
                        <path fill="#00a4ef" d="M1 12h10v10H1z"/>
                        <path fill="#7fba00" d="M12 1h10v10H12z"/>
                        <path fill="#ffb900" d="M12 12h10v10H12z"/>
                    </svg>
                </div>}
                Login with {provider.name}

              </Button>
            </div>
          )
        })}
      </>}
    </>
  )
}
